import React, { useState } from 'react';

import Button from 'CommonComponents/Button';
import SelectInput from 'CommonComponents/SelectInput';

/**
 * Picks one of the events not yet attached to this venue. With none left to
 * attach it says so instead; detaching stays on the venue screen.
 */
export default function AttachEventForm({ venue, events, onSubmit, onCancel }) {
    const attachedIds = venue.events.map((event) => event.id);
    const available = events.filter((event) => !attachedIds.includes(event.id));
    const [sportId, setSportId] = useState(available[0]?.id ?? '');
    const [error, setError] = useState('');
    const [submitting, setSubmitting] = useState(false);

    if (available.length === 0) {
        return (
            <div className="tw-flex tw-items-center tw-gap-3 tw-px-4 tw-py-3 tw-rounded-lg tw-border tw-border-charcoal-15 tw-bg-background">
                <p className="tw-flex-1 tw-mb-0 tw-text-sm tw-text-charcoal-75">
                    {events.length === 0
                        ? $t('No events yet. Add them on the Events step to attach them here.')
                        : $t('Every event is already attached to this venue.')}
                </p>
                <Button variant="outline" small onClick={onCancel}>
                    {$t('Close')}
                </Button>
            </div>
        );
    }

    const submit = (e) => {
        e.preventDefault();
        setSubmitting(true);
        setError('');

        onSubmit(venue, Number(sportId))
            .catch((err) => {
                const errors = err?.response?.data?.errors;
                if (errors) {
                    setError(Object.values(errors).flat().join(' '));
                }
            })
            .finally(() => setSubmitting(false));
    };

    return (
        <form
            className="tw-flex tw-items-start tw-gap-2 tw-w-full tw-px-4 tw-py-3 tw-rounded-lg tw-border tw-border-charcoal-15 tw-bg-background"
            onSubmit={submit}
        >
            <div className="tw-flex-1">
                <SelectInput
                    id={`setup-wizard-attach-${venue.id}`}
                    name={`setup-wizard-attach-${venue.id}`}
                    aria-label={$t('Event to attach to {{venue}}', { venue: venue.name })}
                    value={sportId}
                    disabled={submitting}
                    showError={!!error}
                    errorText={error}
                    onChange={(e) => {
                        setError('');
                        setSportId(e.target.value);
                    }}
                >
                    {available.map((event) => (
                        <option key={event.id} value={event.id}>
                            {event.name}
                        </option>
                    ))}
                </SelectInput>
            </div>
            <Button type="submit" variant="primary" small loading={submitting} disabled={submitting}>
                {$t('Attach')}
            </Button>
            <Button variant="outline" small disabled={submitting} onClick={onCancel}>
                {$t('Cancel')}
            </Button>
        </form>
    );
}
